/**
 * Evita que un tooltip de v-tippy quede abierto por un foco que no puso el
 * usuario con el teclado.
 *
 * Los tooltips abren con "mouseenter focus" (default de tippy.js 4). Al cerrarse
 * un modal u offcanvas abierto con data-bs-toggle, Bootstrap le devuelve el foco
 * al botón que lo abrió (trigger.focus() en hidden.bs.modal), y ese foco abría
 * el tooltip, que quedaba pegado hasta hacer clic en otra parte. Lo mismo con
 * cualquier .focus() hecho por código.
 *
 * Por eso el foco solo abre el tooltip si la última interacción fue con el
 * teclado (navegar con Tab, cerrar el modal con Esc), igual que el anillo de
 * foco del navegador. El hover y el clic no cambian.
 */
let ultimaInteraccionTeclado = false;

document.addEventListener(
  "keydown",
  (e) => {
    // Un atajo (Ctrl+C, Alt+Tab...) no es navegar con el teclado
    if (e.metaKey || e.altKey || e.ctrlKey) return;
    ultimaInteraccionTeclado = true;
  },
  true
);
document.addEventListener(
  "pointerdown",
  () => {
    ultimaInteraccionTeclado = false;
  },
  true
);

// Instancias cuyo próximo show viene de un foco sin teclado
const focoSinTeclado = new WeakSet();

/**
 * Hooks de tippy para Vue.use(VueTippy, ...): llegan a todos los v-tippy y a
 * <tippy>. Si un v-tippy define su propio onShow u onTrigger, reemplaza estos.
 */
export const opcionesFocoTippy = {
  // tippy 4 llama a onTrigger con el evento justo antes de show()
  onTrigger(instance, event) {
    if (event.type === "focus" && !ultimaInteraccionTeclado) {
      focoSinTeclado.add(instance);
    } else {
      focoSinTeclado.delete(instance);
    }
  },
  // false cancela el show
  onShow(instance) {
    const bloquear = focoSinTeclado.has(instance);
    focoSinTeclado.delete(instance);
    return !bloquear;
  },
};
